<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Asociar Órdenes y Compras
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5066]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5066]" [permissionType]="permissionType.ALL">
				<i class="bx bxs-check-circle"></i>Órdenes → Compras
			</label>

			<!-- <input type="radio" [appCheckPermission]="[5066]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(1)" name="pcss3t"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5066]" [permissionType]="permissionType.ALL">
				<i class="fa fa-arrows-turn-right"></i>Compras → Órdenes
			</label> -->

		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-order-association *ngIf="history==0"></app-order-association>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-purchase-association *ngIf="history==1"></app-purchase-association>
			</div>
		</div>
	</div>

</div>